
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, list_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1, TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { AddVisibleReceiversToUserDto_$reflection, AddVisibleReceiversToUserDto, Receiver_$reflection } from "../../../Shared/User.js";
import { VisibleReceiver_$reflection } from "../../../Shared/Receiver.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { empty, toArray, contains, filter, map, ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { createObj, stringHash } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import Shipment_Add from "../../../../public/assets/icons/Shipment_Add.svg";
import { TableControlElement$1, TableControl$1 } from "../../../Widgets/Table/Table.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";
import { Skeleton } from "../../../Components/Skeleton.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SaveReceiverIds", "ReceiverIdsSaved", "ReceiversFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("ToolBox.Modals.AddVisibleReceiverModal.Msg", [], Msg, () => [[["Item", list_type(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(Receiver_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(Receivers, UserId, SuccessCallback, OnClose, FormState, UserData, VisibleReceivers) {
        super();
        this.Receivers = Receivers;
        this.UserId = UserId;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.UserData = UserData;
        this.VisibleReceivers = VisibleReceivers;
    }
}

function State_$reflection() {
    return record_type("ToolBox.Modals.AddVisibleReceiverModal.State", [], State, () => [["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["UserId", string_type], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["UserData", TokenDataDto_$reflection()], ["VisibleReceivers", list_type(VisibleReceiver_$reflection())]]);
}

function init(successCallback, onClose, visibleReceivers, userData, userId) {
    let businessUnitId;
    return [new State(new RequestedValue$1(0, []), userId, successCallback, onClose, FormState_get_empty(), userData, visibleReceivers), Cmd_batch(singleton((businessUnitId = undefined, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/visible-receivers", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1]))))))];
}

function update(msg, state) {
    let body;
    switch (msg.tag) {
        case 1: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.Receivers, state.UserId, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.UserData, state.VisibleReceivers), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return [new State(state.Receivers, state.UserId, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.UserData, state.VisibleReceivers), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 2: {
            const visibleReceiverIds = map((visibleReceiver) => visibleReceiver.Id, state.VisibleReceivers);
            return [new State(new RequestedValue$1(1, [filter((receiver) => !contains(receiver.Id, visibleReceiverIds, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }), msg.fields[0])]), state.UserId, state.SuccessCallback, state.OnClose, state.FormState, state.UserData, state.VisibleReceivers), Cmd_none()];
        }
        case 3:
            return [new State(state.Receivers, state.UserId, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.UserData, state.VisibleReceivers), Cmd_none()];
        default:
            if (state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new AddVisibleReceiversToUserDto(msg.fields[0]);
                return [new State(state.Receivers, state.UserId, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.UserData, state.VisibleReceivers), (body = toString(0, Auto_generateBoxedEncoder_437914C6(AddVisibleReceiversToUserDto_$reflection(), undefined, undefined, undefined)(dto)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), [concat("/api/receivers/", state.UserId, ..."/visible-receivers"), body], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(3, [Item_1]))))];
            }
    }
}

function Content(props) {
    let elems_1, elems, TableRows, Options;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col", "p-4"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.Receivers), (Options = {
        BorderStyle: "full",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: false,
        WithQueryParameters: false,
    }, {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "text", "text"), new ColumnDefinition$1("receiverType", "", t("general.receiver"), (dto) => {
            let matchValue;
            return new CellContent(0, [(matchValue = dto.ReceiverType, (matchValue.tag === 0) ? t("receivers.users") : ((matchValue.tag === 2) ? t("receivers.externalpersons") : ((matchValue.tag === 3) ? t("receivers.subcontractors") : ((matchValue.tag === 4) ? t("receivers.rooms") : ((matchValue.tag === 5) ? t("receivers.projects") : ((matchValue.tag === 6) ? t("receivers.constructionsites") : ((matchValue.tag === 7) ? t("receivers.students") : ((matchValue.tag === 8) ? t("receivers.school_classes") : ((matchValue.tag === 9) ? t("receivers.vehicles") : ((matchValue.tag === 10) ? t("receivers.api_receivers") : t("receivers.employees")))))))))))]);
        }, "text", "text")],
        Controls: singleton(new TableControlElement$1(0, [new TableControl$1(t("general.add"), Shipment_Add(), (row_1) => {
            props.Dispatch(new Msg(0, [map((row_2) => row_2.Id, row_1)]));
        }, true, false, "add-visible-receiver-modal-add")])),
        Options: Options,
        TableKey: "add-visible-receivers",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function AddVisibleReceiverToUserModal(props) {
    let elems, matchValue;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.VisibleReceiver, props.UserData, props.UserId), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    return reactElement("div", createObj(singleton((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.Receivers, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            Receivers: matchValue.fields[0],
        })),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

